import "./HackathonSection.css";
import eventData from './data/event-details.json';
import eventsData from './data/events.json';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';

export default function HackathonSection() {
  const hackathonData = eventData.flagship.Hackathon;
  const hackathonEvent = eventsData.flagship.find(event => event.title === 'Hackathon');
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <section className="hackathon-container">
      
      <h2 className="section-title">Hackathon Details</h2>

      {/* Hero Section */}
      <div className="hackathon-hero">
        <h3 className="hero-tagline">{hackathonData.oneLiner}</h3>
      </div>

      {/* Themes */}
      <div className="themes-section">
        <h3 className="themes-title">Challenge Themes</h3>
        <div className="themes-grid">
          <div className="theme-card">
            <i className="fas fa-brain"></i>
            <span>Generative AI & Intelligent Automation</span>
          </div>
          <div className="theme-card">
            <i className="fas fa-shield-alt"></i>
            <span>Cybersecurity & Digital Trust</span>
          </div>
          <div className="theme-card">
            <i className="fas fa-heartbeat"></i>
            <span>HealthTech & Wellness</span>
          </div>
          <div className="theme-card">
            <i className="fas fa-seedling"></i>
            <span>AgriTech & Sustainability</span>
          </div>
          <div className="theme-card">
            <i className="fas fa-graduation-cap"></i>
            <span>Smart Education (EdTech)</span>
          </div>
          <div className="theme-card">
            <i className="fas fa-city"></i>
            <span>Smart Cities / Urban Innovation</span>
          </div>
          <div className="theme-card">
            <i className="fas fa-lightbulb"></i>
            <span>Open Innovation</span>
          </div>
        </div>
      </div>

      {/* Info Cards */}
      <div className="info-grid">
        <div className="info-card purple">
          <h3>Registration</h3>
          <p>Abstract Submission: ₹99</p>
          <p>Shortlisted Teams: ₹299</p>
          <p>Deadline for Abstract Submission : 26 Jan 2026</p>
        </div>

        <div className="info-card blue">
          <h3>Team Details</h3>
          <p>Team Size: {hackathonData.teamSize} members</p>
          <p>Presentations start at 2:00 PM</p>
          <p>Teams can attend other events during free time</p>
        </div>

        <div className="info-card purple">
          <h3>Event Schedule</h3>
          <p>Date: 30 Jan 2026</p>
          <p>Time : 9:00 AM - 4:30 PM</p>
          <p>Venue: Coimbatore Institute of Technology</p>
          <p>Mode: Offline</p>

        </div>
      </div>

      {/* Register Button */}
      <div className="register-wrapper">
        <button 
          className={`register-btn ${hackathonEvent?.status === 1 ? 'disabled' : ''}`}
          onClick={() => {
            if (hackathonEvent?.status === 1) return;
            if (!user) {
              alert('Please login before registering for events');
              return;
            }
            window.open('https://docs.google.com/forms/d/e/1FAIpQLSevqIS1mJdjGKtmQJUNt2vKG1AH89UGPsUiKikFKCtbpZFacQ/viewform?usp=header', '_blank');
          }}
          disabled={hackathonEvent?.status === 1}
        >
          {hackathonEvent?.status === 1 ? 'Registration Closed' : 'Register Now'}
        </button>
      </div>

    </section>
  );
}
